export enum ListLpFeesCategory {
  DueUnapprovedFees = 'dueUnapprovedFees',
  FutureUnapprovedFees = 'futureUnapprovedFees',
  ApprovedFees = 'approvedFees',
}
